module.exports = __webpack_public_path__ + "img/bj.2ef8dddb.png";